import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import fileDownload from 'js-file-download';
import { NavLink } from 'react-router';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { detectExt } from '../../../utils/utils';

export default function ViewFile(props) {
  const {
    file = {},
    isDownloadAvailable = true,
    prevCrumbs = null,
    title = '',
    handleClose = () => {},
  } = props;
  const dispatch = useDispatch();

  const [isLoadPlugin, setIsLoadPlugin] = useState(false);
  const [isPlugin, setIsPlugin] = useState(false);

  useEffect(() => {
    detectExt('gbkeegbaiigmenfmjfclcdgdpimamgkj').then(() => {
      setIsLoadPlugin(true);
      setIsPlugin(true);
    }).catch(() => {
      setIsLoadPlugin(true);
    });
  }, []);

  const handleDownload = () => {
    fileDownload(file?.url, file?.file_name);
  };

  return (
    <Dialog
      onClose={handleClose}
      open
      className={classNames('file-viewer')}
      size="xl"
    >
      <DialogTitle
        header={(
          <div className="page-title d-sm-flex">
            <div className="title-text">{title || 'Просмотр файла'}</div>
          </div>
        )}
        title={(
          <div>
            <NavLink
              className="me-5"
              target="_blank"
              to="https://chromewebstore.google.com/detail/%D1%80%D0%B5%D0%B4%D0%B0%D0%BA%D1%82%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D0%B5-%D1%84%D0%B0%D0%B9%D0%BB%D0%BE%D0%B2-off/gbkeegbaiigmenfmjfclcdgdpimamgkj"
            >Установить
              плагин
            </NavLink>
            <Icons onClick={handleClose} customIcon icon="close" className="close" />
          </div>
)}
      />
      <DialogContent>
        {!isLoadPlugin ? 'Проверка плагина' : null}
        {isPlugin && isLoadPlugin && file && file.url
          ? <iframe title="Просмотр файла" src={file?.url || ''} frameBorder="0" width="100%" height="100%" /> : null}
        {isLoadPlugin && (!file || !file.url) ? <div className="file-not-found">Файл не найден</div> : null}
        {isLoadPlugin && !isPlugin ? (
          <NavLink
            target="_blank"
            to="https://chromewebstore.google.com/detail/%D1%80%D0%B5%D0%B4%D0%B0%D0%BA%D1%82%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D0%B5-%D1%84%D0%B0%D0%B9%D0%BB%D0%BE%D0%B2-off/gbkeegbaiigmenfmjfclcdgdpimamgkj"
          >Плагин не установлен или выключен
          </NavLink>
        ) : null}
      </DialogContent>
      <DialogFooter className="modal-buttons">
        {isDownloadAvailable ? (
          <Button
            variant="secondary"
            className="download-button"
            onClick={handleDownload}
          >
            <Icons customIcon className="file-download" width={24} height={24} icon="download" />
            <span className="download-button-text">Скачать</span>
          </Button>
        ) : null}
      </DialogFooter>
    </Dialog>
  );
}
